const titles = document.querySelectorAll(".multiple-collections__collection__title");

titles.forEach((title) => {
  title.addEventListener("click", function () {
    // Remove the 'selected' class from all titles
    titles.forEach((t) =>
      t.classList.remove("multiple-collections__collection__title__selected")
    );

    // Add the 'selected' class to the clicked title
    this.classList.add("multiple-collections__collection__title__selected");
  });
});
